"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeInvoices = void 0;
const luxon_1 = require("luxon");
const invoice_1 = require("./utils/invoice");
const castValueToDateTime = (value) => (value instanceof luxon_1.DateTime
    ? value
    : luxon_1.DateTime.fromISO(value));
const castPeriodToDateTime = (object) => (Object.assign(Object.assign({}, object), { start: castValueToDateTime(object.start), end: castValueToDateTime(object.end) }));
const deserializeInvoices = (invoices) => invoices.map((invoice) => (Object.assign(Object.assign(Object.assign({}, invoice), castPeriodToDateTime(invoice)), { shifts: invoice.shifts.map((shift) => (Object.assign(Object.assign({}, shift), castPeriodToDateTime(shift)))) })));
exports.deserializeInvoices = deserializeInvoices;
const processInvoices = (inputInvoices) => new Promise((resolve, reject) => {
    try {
        resolve(invoice_1.groupInvoicesByMonth(exports.deserializeInvoices(inputInvoices))
            .map(({ start, invoices }) => ({
            start,
            weeks: invoice_1.groupInvoicesInMonthByWeek(start, invoices),
        })));
    }
    catch (error) {
        reject(error);
    }
});
exports.default = processInvoices;
//# sourceMappingURL=process.js.map